import React from "react";
import "antd/dist/reset.css";
import "../../containers/customLayout.css";
import '../../App.css';
import { Col, Row, Image, Divider, Button } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import AboutEventTracker from "./AboutEventTracker";
import { useNavigate } from "react-router-dom";
import { ParagraphHeader } from "@seims/shared";
import { ReactComponent as ManageEvents } from "../../assets/manage-events.svg";
import { ReactComponent as IndividualAttendees } from "../../assets/individual-attendees.svg";
import { ReactComponent as AttendanceSummary } from "../../assets/attendance-summary.svg";
import { ReactComponent as GroupAttendees } from "../../assets/group-attendees.svg";
import { ReactComponent as EventLocation } from "../../assets/event-location.svg";
import { ReactComponent as OfflineCapabilities } from "../../assets/offline-capabilities.svg";
import ProgrammeSubscription from "../programme/ProgrammeSubscription";
import { programmes } from "../../utils/apiConstants";

const EventTrackerView = () => {
  const programme = programmes.find(p => p.key === 'events-tracker');
  const navigate = useNavigate();
  return (
    <>
      <div className="events-background">
        <div>
          <Image
            src={require("../../assets/events-app.png")}
            preview={false}
            alt="SEIMS Events App"
            style={{
              maxHeight: "500px"
            }}
          />
        </div>
      </div>
      <p></p>
      <AboutEventTracker />

      <div className="programme-background" style={{ paddingTop: "16px" }}>
        <div className="public-portal-programme">
          <h2>Features of the SEIMS Events App</h2>
          <Row style={{ justifyContent: "center" }} >
            <Col xs={24} sm={16} >
              <div className="event-features">
                <div className="event-feature">
                  <Image
                    alt="image"
                    width={80}
                    src={require(`../../assets/icon-calendar.png`)}
                    preview={false}
                    style={{ display: "inline-block" }}
                  />
                  <h3 className="event-feature-title">Manage Events - Create, Edit and Delete Events</h3>
                </div>
                <div className="event-feature">
                  <Image
                    alt="image"
                    preview={false}
                    width={80}
                    src={require(`../../assets/icon-avatar.png`)}
                    style={{ display: "inline-block" }}
                  />
                  <h3 className="event-feature-title">Capture Individual Attendees</h3>
                </div>
                <div className="event-feature">
                  <Image
                    alt="image"
                    preview={false}
                    width={80}
                    src={require(`../../assets/icon-reports.png`)}
                    style={{ display: "inline-block" }}
                  />
                  <h3 className="event-feature-title">View Attendance Summary</h3>
                </div>
                <div className="event-feature">
                  <Image
                    alt="image"
                    preview={false}
                    width={80}
                    src={require(`../../assets/icon-location.png`)}
                    style={{ display: "inline-block" }}
                  />
                  <h3 className="event-feature-title">Record Event Location</h3>
                </div>
                <div className="event-feature">
                  <Image
                    alt="image"
                    preview={false}
                    width={80}
                    src={require(`../../assets/icon-bus.png`)}
                    style={{ display: "inline-block" }}
                  />
                  <h3 className="event-feature-title">Capture Group Attendees</h3>
                </div>
                <div className="event-feature">
                  <Image
                    alt="image"
                    preview={false}
                    width={80}
                    src={require(`../../assets/icon-wifi.png`)}
                    style={{ display: "inline-block" }}
                  />
                  <h3 className="event-feature-title">Offline Capabilities</h3>
                </div>
              </div>
            </Col>
          </Row>
          {/* <Row >

            <Col xs={6} md={6}>
              <ManageEvents />
            </Col>
            <Col xs={6} md={6}>
              <IndividualAttendees />
            </Col>
            <Col xs={6} md={6}>
              <AttendanceSummary />
            </Col>
          </Row>
          <p></p>
          <Row>
            <Col xs={2} md={2}></Col>
            <Col xs={6} md={6}>
              <EventLocation />
            </Col>
            <Col xs={6} md={6}>
              <GroupAttendees />
            </Col>
            <Col xs={6} md={6}>
              <OfflineCapabilities />
            </Col>
          </Row> */}
          <p></p>
        </div>
      </div>
      <div className="programme-download" style={{ paddingTop: "16px", paddingBottom: "30px" }}>
        <ParagraphHeader header="Download SEIMS Events App" />
        <Row style={{ justifyContent: "center", paddingTop: "16px" }}>
          <Col xs={12} md={6} style={{ display: "flex", justifyContent: "center" }}>
            <Image
              src={require("../../assets/event-app.png")}
              preview={false}
              alt="SEIMS Events App"
            />
          </Col>
          {/* className="app-info" Moving buttons lower if we remove the app link*/}
          <Col xs={22} md={6} style={{ paddingLeft: "0px"}}>
            <p style={{ fontSize: "20px", textAlign: "center" }}>Please click below button to downoad the app from the Google Play Store</p>
            {/* <p style={{ fontSize: "20px", textAlign: "center" }}>Please click below to download the SEIMS Events App</p> */}
            <div className="extra-information-links" style={{ textAlign: "center", paddingBottom: "20px" }}>
              <Button type="link" style={{border:"none",  marginBottom:"15px" }} href="https://play.google.com/store/apps/details?id=za.gov.dsiseimsevents" >
                {/* <CloudDownloadOutlined style={{ fontSize: 16, color: "#fff" , paddingTop:"3px"}} /> <span>Download</span> */}
                 <Image
                src={require("../../assets/google-play.png")}
                alt="Events Tracker"
                style={{ maxWidth: "200px", marginTop:"0px"}}
                preview={false}
              />
            </Button>
            </div>
            <br></br>
  
            <p style={{ fontSize: "20px", textAlign: "center" }}>For more information, please read the User Guide or visit the SEIMS Events App FAQ page</p>
            <div className="extra-information-links" style={{ textAlign: "center" }}>
              <Button className="user-guide-button" type="primary" shape="round" onClick={() => navigate("/user-guides")}>User Guides</Button>&nbsp;&nbsp;
              <Button className="faq-button" type="primary" shape="round" onClick={() => navigate("/faq")}>SEIMS Events App FAQ</Button>
            </div>
          </Col>
        </Row>
        {/* <Divider /> */}
        {/* <ProgrammeSubscription programme={programme} showButton={true} /> */}
      </div>
    </>
  );
}

export default EventTrackerView;